export const getBatchedQueries = async <T>(
  getCount: () => number | Promise<number>,
  getData: (batchSize: number, page: number) => Promise<T[]>,
  batchSize: number
): Promise<T[]> => {
  const totalItems = await getCount();
  const numberOfBatches = Math.ceil(totalItems / batchSize);

  const batchArray = Array.from({ length: numberOfBatches }).map((_, i) =>
    getData(batchSize, i + 1)
  );

  return (await Promise.all(batchArray)).flat();
};
